import {
  ElButton,
  ElMenu,
  ElMenuItem,
  ElSubmenu,
  ElInput,
  ElRow,
  ElCol,
  ElDrawer,
  ElDivider,
  ElAvatar,
  ElCard,
  ElEmpty,
  ElContainer,
  ElBreadcrumb,
  ElBreadcrumbItem,
  ElTable,
  ElTableColumn,
  ElScrollbar,
  ElAffix,
  ElLink,
  ElImage,
  ElDescriptions,
  ElDescriptionsItem,
  ElTabs,
  ElTabPane,
  ElForm,
  ElFormItem,
  ElTimeline,
  ElTimelineItem,
  ElSelect,
  ElOption,
  ElLoading,
  ElPopover,
  ElPopconfirm,
  ElCarousel,
  ElCarouselItem,
  ElCollapse,
  ElCollapseItem,
  ElDialog
} from 'element-plus'
export default app => {
  app.use(ElButton)
  app.use(ElMenu)
  app.use(ElMenuItem)
  app.use(ElSubmenu)
  app.use(ElInput)
  app.use(ElRow)
  app.use(ElCol)
  app.use(ElDrawer)
  app.use(ElDivider)
  app.use(ElAvatar)
  app.use(ElCard)
  app.use(ElEmpty)
  app.use(ElContainer)
  app.use(ElBreadcrumb)
  app.use(ElBreadcrumbItem)
  app.use(ElTable)
  app.use(ElTableColumn)
  app.use(ElScrollbar)
  app.use(ElAffix)
  app.use(ElLink)
  app.use(ElImage)
  app.use(ElDescriptions)
  app.use(ElDescriptionsItem)
  app.use(ElTabs)
  app.use(ElTabPane)
  app.use(ElForm)
  app.use(ElFormItem)
  app.use(ElTimeline)
  app.use(ElTimelineItem)
  app.use(ElSelect)
  app.use(ElOption)
  app.use(ElLoading)
  app.use(ElPopover)
  app.use(ElPopconfirm)
  app.use(ElCarousel)
  app.use(ElCarouselItem)
  app.use(ElCollapse)
  app.use(ElCollapseItem)
  app.use(ElDialog)
}
